import { SPLASHES_TYPES } from '../constants';

const formatSplash = (splash) => {
    const {
        text: label,
        text_color: color,
        background_color: backgroundColor,
        tooltip = null
    } = splash;

    return ({
        label, color, backgroundColor, tooltip
    });
};

export const parseTextSplashes = ({ splashes, showSplashes, showDiscountSplashes }) => {
    if (!showSplashes && !showDiscountSplashes) {
        return [];
    }

    const splashesValues = Object.values(splashes);

    const filterBySplashType = ({ type }) => {
        if (!showSplashes) {
            return type !== SPLASHES_TYPES.TEXT;
        }

        if (!showDiscountSplashes) {
            return type !== SPLASHES_TYPES.DISCOUNT;
        }

        return true;
    };

    const parsedSplashes = splashesValues
        .filter(filterBySplashType)
        .map(formatSplash);

    return parsedSplashes;
};

const parseImageSplash = (imageSplash, showImageSplashes) => {
    if (!showImageSplashes || !imageSplash) {
        return [];
    }

    const { url, tooltip } = imageSplash;

    return [{ src: url, alt: url, tooltip }];
};

export const parseProductCardSplashes = (splashes, imageSplash, cardConfig) => {
    const {
        showSplashes, showImageSplashes, showDiscountSplashes
    } = cardConfig;

    if ((showSplashes || showImageSplashes || showDiscountSplashes) && (splashes || imageSplash)) {
        return {
            box: parseTextSplashes({
                splashes,
                showSplashes,
                showDiscountSplashes
            }),
            image: parseImageSplash(imageSplash, showImageSplashes)
        };
    }

    return null;
};

export const getPriceSplash = (optinBox, isActiveDealsOn, hasSimplePrice) => {
    if (hasSimplePrice || !optinBox) {
        return null;
    }

    const {
        text: label,
        text_color: color,
        background_color: backgroundColor
    } = optinBox || {};
    return !isActiveDealsOn ? {
        label,
        color,
        backgroundColor
    } : {};
};

export const getProductCardAttributes = (
    attribute, cardConfig, isInStock
) => {
    const { cardStrings, showSustainabilityAttributes, showIsInStockAttributes = true } = cardConfig;

    if (!isInStock && showIsInStockAttributes) {
        return [cardStrings.soldOutLabel];
    }

    const { text } = attribute || {};

    if (showSustainabilityAttributes && text) {
        return [text];
    }

    return [];
};
